<template>
  <NavBar />
  <header class="lg:px-16 px-5 bg-white flex flex-wrap items-center py-3">
    <div class="flex-1 flex justify-between items-center">
      <div class="relative">
        <a href="javascript.void(0)" class="block text-3xl font-redHat text-[#5FBAE6] font-bold">
          Laporan Penjualan
        </a>
        <!-- <p class="block text-xl font-redHat text-[#F5CA40] font-bold">Verifikasi Data</p> -->
      </div>
      <!-- <p class="block text-xl font-redHat text-[#F5CA40] font-bold">Story Instagram</p> -->
    </div>

    <div class="hidden md:flex md:items-center md:w-auto w-full" id="menu">
      <nav>

        <ul class="md:flex items-center justify-between text-base text-gray-700 pt-3 md:pt-0 gap-1">
          <li v-if="this.records && this.records.length > 0">
            <div @click="convertToExcel"
              class="font-redHat text-base  h-[40px] w-[150px] rounded-md text-green-600  border-2 border-green-600 me-2 cursor-pointer">
              <div class="flex justify-center items-center h-full gap-2">
                <img src="../../../assets/img/icon_excel.png" alt="">
                Export Excel
              </div>
            </div>
          </li>

          <li>
            <div
              class="relative flex items-center p-0 rounded-[8px] w-[250px] max-w-lg h-[40px] border-[0.5px] border-[#00000]">
              <input type="text" v-model="searchQuery" @input="filterTable"
                class="rounded-[8px] p-2.5 px-6 w-full h-full focus:border-blue-500 focus:ring focus:ring-blue-200 focus:outline-none"
                name="search" placeholder="Cari">

              <button type="submit"
                class="absolute right-2 top-1/2 transform -translate-y-1/2 z-10 bg-white  p-2 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                </svg>
              </button>
            </div>
          </li>
          <!-- <li>
            <Datepicker v-model="dateRange" range="true" lang="id" class="" position="right" />
          </li> -->

          <!-- <div class="relative p-0 rounded-[20px] w-[250px] max-w-lg"> -->
          <!-- <input type="text" class="rounded-[20px] p-3 w-full" name="search" placeholder="Cari"> -->
          <!-- </div> -->
          <!-- <li>
              <RouterLink to="addcustomer"
                class="md:p-4 py-3 block flex items-center justify-center w-[200px] h-[40px] rounded-md bg-[#50C996] text-black py-2.5 font-semibold"
              >
                Customer Baru
              </RouterLink>
            </li> -->

          <!-- <input type="date" v-model="date" class="flex-grow border-1 border-[#5FBAE6] rounded-md p-2" name="date"> -->
          <!-- <li>
            <button @click="filterDropdown = !filterDropdown" id="dropdownHoverButton"
              class="md:p-4 py-3 px-0 block flex items-center justify-center w-[100px] h-[40px] rounded-md bg-[#F5CA40] text-black px-6 py-2.5 font-semibold gap-2">
              Filter By <i class="bi bi-funnel-fill"></i>
            </button>
            <ul v-if="filterDropdown"
              class="absolute transform -translate-x-2  bg-slate-100 shadow-lg mt-2 rounded-lg w-30 space-y-2 p-1"> 
              <li
                class="block px-4 py-2 text-black font-redHat text-base hover:bg-[#5FBAE6]/80 hover:rounded-lg cursor-pointer"
                :class="{ 'bg-[#5FBAE6]/80 rounded-lg': selectedType === 'STORY_IG' }"
                @click="filterRecords('STORY_IG')">
                <div>List Order</div>
              </li>
              <li
                class="block px-4 py-2 text-black font-redHat text-base hover:bg-[#5FBAE6]/80 hover:rounded-lg cursor-pointer"
                :class="{ 'bg-[#5FBAE6]/80 rounded-lg': selectedType === 'LIVE_IG' }" @click="filterRecords('LIVE_IG')">
                <div>Live Instagram</div>
              </li>
            </ul>
          </li> -->
        </ul>
      </nav>
    </div>
  </header>

  <div class="px-5 pt-5 mb-2">
    <!-- <div class="flex flex-col">
              <div class=" overflow-x-auto">
                  <div class="p-1.5 min-w-full inline-block align-middle">
                      <div class="">
                      </div>
                  </div>
              </div>
          </div> -->


    <div class="overflow-scroll" style="max-height: 60vh;">
      <!-- for datatable -->
      <table id="example" class="display" style="width: 100%;">
        <thead style="position: sticky; top: 0; background-color: white; z-index: 1;">
          <tr v-if="filteredRecords.length > 0">
            <th styles="width: 100px;">No.</th>
            <th>Instagram</th>
            <th>Customer</th>
            <th>ID Customer</th>
            <!-- <th>Status Pesanan</th>
            <th>Tipe Jual</th> -->
            <!-- <th>Tanggal Sales</th> -->
            <!-- <th>Kode Produk</th>
            <th>Produk</th> -->
            <!-- <th>Varian</th>
            <th>Size</th> -->
            <!-- <th>Qty</th> -->
            <!-- <th>Sub total</th>
            <th>Diskon</th>
            <th>Ongkos kirim</th> -->
            <th>Total Sales</th>
            <th>Deposit</th>
            <th>Berat</th>
            <th>Ongkir</th>
            <th>Status</th>
            <!-- <th>Status Invoice</th> -->

            <!-- <th>Verifikasi</th> -->
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr class="tr-table" v-for="(item, index) in filteredRecords" :key="item.id">
            <td class="custom-td-left w-[50px]">{{ index + 1 }}</td>
            <!--<td><input type="text" v-model="item.ig" /></td> -->
            <td class="w-[250px]">
              <div class="m-2">
                <span class="">
                  {{ item.instagram }}
                </span>
              </div>
            </td>
            <td class="w-[200px]">
              <div class="m-2">
                <span class="">
                  {{ item.name }}
                </span>
              </div>
            </td>
            <td class="w-[200px]">
              <div class="m-2">
                <span class="">
                  {{ item.counter_customer }}
                </span>
              </div>
            </td>
            <!-- <td class="w-[150px]">
              <div class="m-2">
                {{ item.order_status }}
              </div>
            </td>
            <td class="w-[200px]">
              <div class="m-2">
                {{ item.type || '' }}
              </div>
            </td> -->
            <!-- <td class="w-[200px]">
              <div class="m-2">
                {{ item.sale_date || '' }}
              </div>
            </td> -->
            <!-- <td class="w-[200px]">
              <div class="m-2">
                {{ item.product_code }}
              </div>
            </td> -->
            <!-- <td class="w-[200px]">
              <div class="m-2">
                {{ item.product_name }}
              </div>
            </td> -->
            <!-- <td class="w-[50px] py-0">
              <div class="m-2">
                {{ item.qty }}
              </div>
            </td> -->
            <!-- <td class="w-[160px]">
              <div class="m-2">
                {{ rupiah(item.price) }}
              </div>
            </td>
            <td class="w-[160px]">
              <div class="m-2">
                {{ rupiah(item.discount) }}
              </div>
            </td>
            <td class="w-[160px]">
              <div class="m-2">
                {{ rupiah(item.shipping_cost_total) }}
              </div>
            </td> -->
            <td class="w-[160px]">
              <div class="m-2">
                {{ rupiah(item.price - item.discount + item.shipping_cost_total) }}
              </div>
            </td>
            <td class="w-[150px]">
              <div class="m-2">
                {{ rupiah(item.total_deposit) }}
              </div>
            </td>
            <td class="w-[150px]">
              <div class="m-2">
                {{ item.weight / 1000 }} kg
              </div>
            </td>
            <td class="w-[150px]">
              <div class="m-2">
                {{ rupiah(item.shipping_cost_total) }}
              </div>
            </td>
            <td class="w-[150px]">
              <div class="m-2"
                v-if="(item.price - item.discount + item.shipping_cost_total <= item.total_deposit) && item.id_invoice > 0">
                LUNAS
              </div>
              <div class="m-2" v-else-if="(item.price - item.discount + item.shipping_cost_total) == 0">
                SOLDOUT
              </div>
              <div class="m-2"
                v-else-if="(item.price - item.discount + item.shipping_cost_total <= item.total_deposit)">
                INVOICE BELUM DICETAK
              </div>
              <div class="m-2" v-else>
                BELUM
              </div>
            </td>
            <!-- <td class="w-[150px]">
              <div class="m-2" v-if="item.id_invoice != null">
                ADA
              </div>
              <div class="m-2" v-else>
                TIDAK
              </div>
            </td> -->
            <td class="custom-td-right w-[150px]">
              <div class="flex justify-between">
                <button type="button" @click="viewData(item)"
                  class="inline-flex items-center gap-x-2 text-lg font-semibold ms-2 text-black hover:text-red-800 disabled:opacity-50 disabled:pointer-events-none">
                  <i class="bi bi-file-earmark-text"></i>
                </button>
              </div>
            </td>

          </tr>
          <tr class="tr-table " v-if="filteredRecords.length > 0 && searchQuery == ''">
            <td colspan="6" class="custom-td-left text-center ">Total</td>
            <td>
              <div class="m-2">{{ total_weight / 1000 }} kg</div>
            </td>
            <td>
              <div class="m-2">{{ rupiah(total_shipping_cost_total) }}</div>
            </td>
            <td colspan="2" class="custom-td-right"></td>
          </tr>
        </tbody>
      </table>
    </div>


  </div>




  <!-- modal delete -->
  <div v-if="isModalOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
    <!-- Modal content -->
    <div class="bg-white rounded-lg shadow-lg p-6 max-w-md w-full" @click.stop>
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-xl font-semibold">Delete Data Rekap</h2>
        <button @click="closeModal" class="text-red-600 hover:text-gray-900">
          ✕
        </button>
      </div>
      <p class="text-gray-700 mb-10">
        Are you sure wants to delete this data ?
      </p>

      <div class="space-y-3">
        <div aria-hidden="true" class="border-t px-2"></div>
        <div class="button-group flex justify-end">
          <button @click="closeModal" class="bg-gray-400 text-white font-bold py-2 px-4 rounded hover:bg-gray-700 me-3">
            Close
          </button>
          <button @click="delete2" class="bg-red-500 text-white font-bold py-2 px-4 rounded hover:bg-red-700">
            Delete
          </button>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
import NavBar from '@/components/NavBar.vue'
import axios from "axios";
// import Swal from 'sweetalert2';

import { ErrorConnectionTimeOut, ShowLoading, CloseLoading, base_url, AlertPopup, AlertBottom, rupiahInput, rupiah, goPage, DateFormat } from "@/assets/js/function";
// import {ErrorConnectionTimeOut,  ShowLoading, CloseLoading, base_url, AlertPopup,  rupiahInput,  rupiah } from "@/assets/js/function";
import Cookies from "js-cookie";
import Multiselect from 'vue-multiselect';
import 'vue-datepicker-ui/lib/vuedatepickerui.css';
import VueDatepickerUi from 'vue-datepicker-ui';
import Viewinvoice from './viewinvoice.vue';
import XLSX from "xlsx/dist/xlsx.full.min.js";


export default {
  components: {
    NavBar,
    Multiselect,
    Datepicker: VueDatepickerUi
  },

  data() {
    return {
      searchQuery: '',

      records: [
        {
          total_deposit: '',
        }
      ],
      currentData: [],
      listStatusPesanan: [],
      isModalOpen: false,
      currentDeleteIndex: null,
      config: '',
      filterDropdown: false,
      selectedType: 'LIVE_IG',
      total_weight: 0,
      total_shipping_cost_total: 0,

      date: '',
      dateRange: [
        new Date(),
        new Date(new Date().getTime() + 9 * 24 * 60 * 60 * 1000)]

    }
  },

  watch: {
    // date: {
    //   handler(newVal) {
    //     this.index();
    //   },
    // }
    dateRange: {
      handler(newVal) {
        this.index();
      },
    }
  },

  created() {
    const token = Cookies.get("token");
    // console.log(token)
    this.config = {
      headers: { Authorization: `Bearer ` + token },
      timeout: 100000,
    }

    const date = new Date();
    this.date = date.toISOString().split('T')[0]; // Output: '2024-05-01'


    // console.log(this.config);
    this.index();
    this.prepareData();


    this.showMultiselect = false;

    // Load from localStorage when the component is created
    // const savedLiveIg = localStorage.getItem('records');
    // if (savedLiveIg) {
    // this.records = JSON.parse(savedLiveIg); // Load saved data into records
    // console.log('Stored records:', JSON.parse(savedLiveIg));
    // }else {
    // console.log('No records found in localStorage.');
    // }
  },

  computed: {
    filteredRecords() {

      if (!this.searchQuery) {
        return this.records;
      }


      return this.records.filter(item => {
        const searchLower = this.searchQuery.toLowerCase();


        // const totalPrice = item.price ? (item.price - item.discount + item.shipping_cost_total) : 0;

        const paymentStatus = this.getPaymentStatus(item);



        return (
          (item.instagram ? item.instagram.toLowerCase().includes(searchLower) : false) ||
          (item.type ? item.type.toLowerCase().includes(searchLower) : false) ||
          (item.name ? item.name.toLowerCase().includes(searchLower) : false) ||
          (item.counter_customer ? item.counter_customer.toLowerCase().includes(searchLower) : false) ||
          (item.total_deposit ? item.total_deposit.toString().toLowerCase().includes(searchLower) : false) ||
          (item.price ? (item.price - item.discount + item.shipping_cost_total).toString().toLowerCase().includes(searchLower) : false) ||
          (paymentStatus.toLowerCase().includes(searchLower))
        );
      });


    }
  },


  // mounted() {
  //     this.$root.initializeDataTable(); 

  // },

  methods: {
    rupiah,
    goPage,
    getPaymentStatus(item) {
      const totalPrice = item.price - item.discount + item.shipping_cost_total;

      if (totalPrice <= item.total_deposit && item.id_invoice > 0) {
        return 'LUNAS';
      } else if (totalPrice === 0) {
        return 'SOLDOUT';
      } else if (totalPrice <= item.total_deposit) {
        return 'INVOICE BELUM DICETAK';
      } else {
        return 'BELUM';
      }
    },
    Viewinvoice(item) {
      localStorage.setItem('id_customer', item.id_customer);
      goPage('viewinvoice');
    },
    nameWithLang({ name }) {
      return `${name}`;
    },

    addRow() {
      // Mark the row as "Added"
      //   this.record[index].isAdded = true

      // Add a new row with a unique id
      this.records.push({
        id_customer: '',
        id_produk: '',
        color: '',
        size: '',
        qty: '',
        price: '',
        deposit: '',
        isAdded: false
      })
    },

    addNumberToObjects(objArray) {
      let no = 1;
      for (let i = 0; i < objArray.length; i++) {
        const { counter_customer, order_status, name, price, total_deposit, discount, shipping_cost_total, instagram, status_customer, type, weight, ...rest } = objArray[i];
        // let expedition_info_text = expedition_info;
        // if (expedition_info !== '') {
        //   expedition_info_text = ' (' + expedition_info + ') ';
        // }

        const totalPrice = price - discount + shipping_cost_total;

        let status;
        if (totalPrice <= total_deposit && objArray[i].id_invoice > 0) {
          status = 'LUNAS';
        } else if (totalPrice === 0) {
          status = 'SOLDOUT';
        } else if (totalPrice <= total_deposit) {
          status = 'INVOICE BELUM DICETAK';
        } else {
          status = 'BELUM';
        }

        const newObj = {
          No: objArray[i - 1] != undefined && objArray[i - 1]['Id Customer'] == counter_customer ? '' : no,
          "Instagram": instagram,
          "Customer": name,
          "ID Customer": counter_customer,

          "Status Pesanan": order_status,
          // "Ekspedisi": expedition + expedition_info_text,
          // "Nama Admin": nama_admin,
          // "Tipe Jual": type == 'LIVE_IG' ? 'LIVE IG' : 'STORY IG',
          "Total Sales": price - discount + shipping_cost_total,

          "Deposit": total_deposit,
          "Berat": weight / 1000 + ' kg',
          "Ongkir ": shipping_cost_total,
          "Status": status,
          // "Order": order,
          // "Qty": qty,
          // "Total": total_qty + ' PCS',
          ...rest
        };

        // console.log('ini obj dari laporan jual:', newObj)
        if (objArray[i - 1] == undefined || objArray[i - 1]['Id Customer'] != counter_customer) {
          no++;
        }
        objArray[i] = newObj;
      }
      return objArray;
    },

    convertToExcel() {
      ShowLoading();

      // Create a deep copy of `this.records` to avoid modifying the original data
      const data = JSON.parse(JSON.stringify(this.records));
      const ArrExport = this.addNumberToObjects(data);

      for (let i = 0; i < ArrExport.length; i++) {
        delete ArrExport[i]["id"];
        delete ArrExport[i]["id_profiles"];
        delete ArrExport[i]["id_preorder"];
        delete ArrExport[i]["id_customer"];
        delete ArrExport[i]["number"];
        delete ArrExport[i]["name"];
        delete ArrExport[i]["id_product"];
        delete ArrExport[i]["qty"];       // Remove qty key
        delete ArrExport[i]["order"];
        delete ArrExport[i]["discount"];
        delete ArrExport[i]["shipping_cost_total"];
        // delete ArrExport[i]["Tipe Jual"];
        delete ArrExport[i]["weight"];
        delete ArrExport[i]["Nama Admin"];
        delete ArrExport[i]["customer_detail"];
        delete ArrExport[i]["id_invoice"];



        if (ArrExport[i]['No'] == '') {
          ArrExport[i]["Id Customer"] = '';
          // ArrExport[i]["Ekspedisi"] = '';
          ArrExport[i]["Instagram"] = '';
          ArrExport[i]["Tipe Jual"] = '';
          ArrExport[i]["Tipe Sales"] = '';
          ArrExport[i]["Deposit"] = '';
          ArrExport[i]["Status"] = '';

        }
      }

      // Create a new workbook
      const wb = XLSX.utils.book_new();
      // Create a new worksheet
      const ws = XLSX.utils.json_to_sheet(ArrExport);
      // Add the worksheet to the workbook
      XLSX.utils.book_append_sheet(wb, ws, 'REKAP');
      // Convert the workbook to an XLSX file and download it
      XLSX.writeFile(wb, 'PENJUALAN REPORT' + ".xlsx");
      CloseLoading();
    },

    getIconClass(item) {
      // Determine the icon class based on whether the row is the last one
      // return item.total_deposit > item.price ? 'bi bi-check-circle-fill text-gray-400' : 'bi bi-check-circle-fill text-[#50C996]' ;
      // console.log(item.total_deposit)
      // console.log(item.price)
      if (item.total_deposit >= item.price) {
        //return 'bi bi-check-circle-fill text-[#50C996]'; // Green verified
        return true
      }
      else {
        //return 'bi bi-check-circle-fill text-gray-400'; // Gray unverified
        return false
      }
    },

    // checkingLastRow(index) {
    //     if(index == this.records.length - 1) {
    //         // this.records[index].isAdded = true;
    //         return true;

    //             // this.records.splice(index + 1, 0, );
    //     }else {
    //         // this.records[index].isAdded = false;
    //         return false;

    //     }
    // },

    formatCurrency(label, number, index) {
      this.records[index][label] = rupiahInput(number);

    },

    prepareData() {
      // this.records.total_deposit = rupiahInput(this.records.total_deposit);
      this.records.forEach((item) => {
        item.total_deposit = rupiahInput(item.total_deposit);
      });

    },
    viewData(item) {
      // for batal edit customer page
      localStorage.setItem('id_customer', item.id_customer);
      window.open('dailyreportview', 'dailyreportview');
      // goPage('dailyreportview');
    },
    editCustomer(item) {
      // for batal edit customer page
      this.$router.push({ name: 'editcustomer' });
      sessionStorage.setItem('lastPage', 'verifikasi-live-ig');

      // console.log(item)
      localStorage.setItem('currentData', JSON.stringify(item.customer_detail));

      // Navigate to the Add Customer page
      this.$router.push({ name: 'editcustomer' });
    },

    filterRecords(type) {
      this.selectedType = type; // Save the selected filter type
      this.index(); // Call the index method to fetch filtered data
    },

    index() {
      ShowLoading();
      let formData = new FormData();

      formData.append('id_preorder', localStorage.getItem('id_preorder'))

      // const startDate = this.dateRange[0];
      // const StartformattedDate = `${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, '0')}-${String(startDate.getDate()).padStart(2, '0')}`;
      // formData.append('date_from', StartformattedDate);

      // const beforeDate = this.dateRange[1];
      // const BeforeformattedDate = `${beforeDate.getFullYear()}-${String(beforeDate.getMonth() + 1).padStart(2, '0')}-${String(beforeDate.getDate()).padStart(2, '0')}`;
      // formData.append('date_end', BeforeformattedDate);


      if (process.env.NODE_ENV === "development") {
        this.api = base_url + 'report_daily';
      } else {
        this.api = base_url + 'report_daily';
      }

      axios
        .post(this.api, formData, this.config)
        .then((response) => {
          this.records = [];
          // console.log(response.data)
          if (response.data.status === true) {

            this.records = response.data.data;

            this.total_weight = this.records.reduce((sum, item) => sum + item.weight, 0);
            this.total_shipping_cost_total = this.records.reduce((sum, item) => sum + item.shipping_cost_total, 0);
            // this.dataCustomer = response.data.customer; //to fetch customer
            // this.dataProduct = response.data.product; //to fetch product


            CloseLoading();
          } else {
            CloseLoading();
            AlertPopup("error", "", response.data.message, 1500, false);
          }
        })
        .catch((error) => {
          CloseLoading();
          ErrorConnectionTimeOut(error);
        });
    },

    openModalDelete() {
      // this.currentDeleteIndex = index;

      this.isModalOpen = true;
    },

    closeModal() {
      this.isModalOpen = false;
      this.id_terminate = null;
    },

    delete2() {
      ShowLoading();
      let formData = new FormData();
      formData.append("id", this.id_terminate);


      // for (let [key, value] of formData.entries()) {
      //     console.log(`${key}: ${value}`);
      // }
      // CloseLoading()
      // return true;

      if (process.env.NODE_ENV === "development") {
        this.api = base_url + 'live_ig_delete';
      } else {
        this.api = base_url + 'live_ig_delete';
      }

      axios
        .post(this.api, formData, this.config)
        .then((response) => {

          if (response.data.status == true) {
            const index = this.records.findIndex((item) => item.id === this.id_terminate); // Find item in the array by ID
            this.records.splice(index, 1); // Remove the item from the array
            CloseLoading();
            this.closeModal(); // Close modal after deletion
            AlertBottom(response.data.message);

          } else {
            AlertPopup("error", "", response.data.message, 1500, false);
          }
        })
        .catch((error) => {

          ErrorConnectionTimeOut(error);
        });


    },

    terminate(id) {
      this.id_terminate = id;
      this.openModalDelete();
      // this.tanggal_terminate = new Date();

    },

    //   openModalDelete(index) {
    //       this.currentDeleteIndex = index;

    //       this.isModalOpen = true;
    //   },
    //   closeModal() {
    //       this.isModalOpen = false;
    //   },
    //   confirmDelete() {
    //       // Handle the actual deletion here
    //       if (this.currentDeleteIndex !== null) {
    //           this.records.splice(this.currentDeleteIndex, 1);  // Delete the item
    //           this.closeModal();  // Close the modal after deletion
    //       }
    //   },
  }
}
</script>

<style scoped>
/* Adjust positioning and z-index for the multiselect dropdown */
.multiselect__content {
  position: absolute;
  z-index: 9999;
  top: 100%;
}

.multiselect-full-width .multiselect__select {
  width: 100%;
}

.no-arrows {
  -moz-appearance: textfield;
  /* Firefox */
  appearance: none;
  /* Remove default appearance */
}

.no-arrows::-webkit-outer-spin-button,
.no-arrows::-webkit-inner-spin-button {
  -webkit-appearance: none;
  /* Chrome, Safari, Edge */
  margin: 0;
  /* Remove margin */
}
</style>